import { formatCurrency, calculate } from "./util.js";

const LoanCalculator = function( form ) {
	if ( ! form ) {
		return;
	}

	const amount           = form.querySelector('.loan-calculator__amount');
	const amountPreview    = form.querySelector('.loan-calculator__amount-preview');
	const apr              = form.querySelector('.loan-calculator__apr');
	const aprPreview       = form.querySelector('.loan-calculator__apr-preview');
	const aprRange         = form.querySelector('.loan-calculator__apr-range');
	const frequencyPreview = form.querySelector('.loan-calculator__frequency-preview');
	const maxApr           = 24;
	const maxTerm          = 50;
	const minTerm          = 1;
	const paymentPreview   = form.querySelector('.loan-calculator__payment-preview');
	const term             = form.querySelector('.loan-calculator__term');
	const termPreview      = form.querySelector('.loan-calculator__term-preview');
	const termRange        = form.querySelector('.loan-calculator__term-range');

	const getFreqency = () => form.querySelector('.loan-calculator__frequency > input[type="radio"]:checked');

	const applyResult = () => {
		const frequency = getFreqency();

		amountPreview.textContent = formatCurrency( amount.value || 0, 0 );
		frequencyPreview.textContent = frequency.value;
		aprPreview.textContent = apr.value;
		termPreview.textContent = term.value;
		paymentPreview.textContent = calculate( amount.value || 0, apr.value, term.value, frequency.value );
	}

	amount.addEventListener( 'keypress', (e) => {
		if ( /[^0-9,\.]/.test( e.key ) ) {
			e.preventDefault();
			return;
		}
	} );

	apr.addEventListener( 'keypress', (e) => {
		if ( /[^0-9\.]/.test( e.key ) ) {
			e.preventDefault();
			return;
		}
	} );

	apr.addEventListener( 'input', () => {
		if ( parseFloat( apr.value ) > maxApr ) {
			apr.value = maxApr;
		}
	} );

	term.addEventListener('keypress', (e) => {
		if ( /[^0-9\.]/.test( e.key ) ) {
			e.preventDefault();
			return;
		}
	} );

	term.addEventListener( 'input', () => {
		const termValue = parseFloat( term.value );

		if ( isNaN( termValue ) ) {
			term.value = minTerm;
		} else if ( termValue > maxTerm ) {
			term.value = maxTerm;
		} else if ( termValue < minTerm ) {
			term.value = minTerm;
		}

		termRange.value = term.value;
	} );

	aprRange.addEventListener( 'input', () => apr.value = aprRange.value );
	termRange.addEventListener( 'input', () => term.value = termRange.value );
	apr.addEventListener( 'input', () => aprRange.value = apr.value );
	form.addEventListener( 'input', applyResult );
	form.addEventListener( 'change', applyResult );
	applyResult();
}

LoanCalculator.instances = [].map.call( document.querySelectorAll('.loan-calculator'), node => LoanCalculator( node ) );

export default LoanCalculator;
